export default __webpack_public_path__ + "static/media/nft-7.d90fbdd0.gif";